var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendV2 = function SvgSendV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.802 2.202a.67.67 0 0 0-.716-.15L2.421 9.387a.667.667 0 0 0-.11 1.186l5.333 3.333a.67.67 0 0 0 .652.031l3.544-1.772-1.773 3.544a.67.67 0 0 0 .032.651l3.333 5.333a.67.67 0 0 0 .565.314h.062a.67.67 0 0 0 .559-.42L21.95 2.918a.67.67 0 0 0-.15-.717"
  })));
};
export default SvgSendV2;